var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 256 256",
    height: 512,
    viewBox: "0 0 256 256",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 166.484,
    cy: 76.654,
    fill: "#ef7816",
    r: 57.844
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.484,
    cy: 76.654,
    fill: "#ffc91d",
    r: 45.908
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.555 39.584c5.553 7.591 8.838 16.945 8.838 27.07 0 25.354-20.554 45.908-45.908 45.908-10.125 0-19.479-3.285-27.07-8.838 8.351 11.417 21.841 18.838 37.07 18.838 25.354 0 45.908-20.554 45.908-45.908-.001-15.229-7.421-28.719-18.838-37.07z",
    fill: "#ffa91a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.119 72.337h-2.634v-19.173h2.634c5.286 0 9.586 4.3 9.586 9.586 0 1.104.896 2 2 2s2-.896 2-2c0-7.491-6.095-13.586-13.586-13.586h-2.634v-2.635c0-1.104-.896-2-2-2s-2 .896-2 2v2.635h-2.635c-7.491 0-13.586 6.095-13.586 13.586 0 7.492 6.095 13.587 13.586 13.587h2.635v23.807h-2.635c-5.286 0-9.586-4.3-9.586-9.586 0-1.104-.896-2-2-2s-2 .896-2 2c0 7.491 6.095 13.586 13.586 13.586h2.635v2.635c0 1.104.896 2 2 2s2-.896 2-2v-2.635h2.634c7.492 0 13.586-6.095 13.586-13.586v-4.635c0-7.491-6.095-13.586-13.586-13.586zm-9.269 0c-5.286 0-9.586-4.301-9.586-9.587s4.3-9.586 9.586-9.586h2.635v19.173zm18.855 18.221c0 5.286-4.3 9.586-9.586 9.586h-2.634v-23.807h2.634c5.286 0 9.586 4.3 9.586 9.586z",
    fill: "#995222"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 82.437,
    cy: 76.654,
    fill: "#377de2",
    r: 57.844
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.437 18.81c-31.946 0-57.844 25.898-57.844 57.844s25.898 57.844 57.844 57.844 57.844-25.898 57.844-57.844-25.898-57.844-57.844-57.844zm0 111.259c-29.501 0-53.416-23.915-53.416-53.416s23.915-53.416 53.416-53.416 53.416 23.915 53.416 53.416c-.001 29.501-23.916 53.416-53.416 53.416z",
    fill: "#2266d3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.437,
    cy: 76.654,
    fill: "#e6e6e6",
    r: 45.885
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.491 39.6c5.549 7.587 8.831 16.935 8.831 27.054 0 25.342-20.544 45.885-45.885 45.885-10.119 0-19.467-3.283-27.054-8.831 8.347 11.413 21.831 18.831 37.054 18.831 25.342 0 45.885-20.544 45.885-45.885 0-15.223-7.419-28.707-18.831-37.054z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#414042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m102.757 74.674h-14.943c-.577-1.566-1.814-2.808-3.377-3.39v-23.603c0-1.104-.896-2-2-2s-2 .896-2 2v23.603c-2.18.813-3.736 2.907-3.736 5.37 0 3.168 2.568 5.736 5.736 5.736 2.456 0 4.545-1.546 5.363-3.716h14.958c1.104 0 2-.896 2-2s-.897-2-2.001-2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82.437 39.695c-1.104 0-2-.896-2-2v-2.383c0-1.104.896-2 2-2s2 .896 2 2v2.383c0 1.105-.896 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.437 119.995c-1.104 0-2-.896-2-2v-2.383c0-1.104.896-2 2-2s2 .896 2 2v2.383c0 1.105-.896 2-2 2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m43.479 78.654h-2.384c-1.104 0-2-.896-2-2s.896-2 2-2h2.384c1.104 0 2 .896 2 2s-.896 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.778 78.654h-2.383c-1.104 0-2-.896-2-2s.896-2 2-2h2.383c1.104 0 2 .896 2 2s-.895 2-2 2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m232.054 134.464c-.09-.091-.181-.181-.271-.271-4.995-4.995-13.09-4.999-18.084-.002-10.622 10.626-27.725 27.729-35.009 35.015-2.228 2.228-5.236 3.466-8.387 3.466h-24.836c8.202-.042 14.84-6.7 14.84-14.912 0-8.238-6.678-14.916-14.916-14.916h-32.256c-8.029 0-15.716 3.25-21.309 9.01l-20.218 20.819h-7.613v49.667h24.698 58.26c9.454 0 18.52-3.755 25.206-10.439l59.893-59.883c4.848-4.849 4.849-12.706.002-17.554z",
    fill: "#fcc4ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.758 135.243c.209 3.425-.983 6.92-3.6 9.537l-59.893 59.883c-6.685 6.684-15.752 10.439-25.206 10.439h-58.26-21.805v7.236h24.698 58.26c9.454 0 18.52-3.755 25.206-10.439l59.893-59.883c4.599-4.596 4.829-11.897.707-16.773z",
    fill: "#f2ad97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.39 172.675h-26.593v-4.342h23.699c8.238 0 14.916-6.678 14.916-14.916 0-2.116-.447-4.125-1.241-5.949 2.556 2.677 4.135 6.296 4.135 10.291 0 8.237-6.678 14.916-14.916 14.916z",
    fill: "#f2ad97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.353 167.171h3.025c4.418 0 8-3.582 8-8v-2.825c0-4.418-3.582-8-8-8h-3.025c-1.105 0-2 .895-2 2v14.825c0 1.105.896 2 2 2z",
    fill: "#ffd2c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.994 237.19h-33.683c-2.761 0-5-2.239-5-5v-69.372c0-2.761 2.239-5 5-5h33.683c2.761 0 5 2.239 5 5v69.372c0 2.762-2.238 5-5 5z",
    fill: "#478cf7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.311 213.19c-1.104 0-2-.896-2-2v-39c0-1.104.896-2 2-2s2 .896 2 2v39c0 1.105-.895 2-2 2zm0-47c-1.104 0-2-.896-2-2v-.372c0-1.104.896-2 2-2s2 .896 2 2v.372c0 1.105-.895 2-2 2z",
    fill: "#5e9cf7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.994 162.819c0-2.761-2.239-5-5-5h-15v54.372c0 2.761-2.239 5-5 5h-18.683v15c0 2.761 2.239 5 5 5h33.683c2.761 0 5-2.239 5-5z",
    fill: "#377de2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.994 162.819c0-2.761-2.239-5-5-5h-5v64.372c0 2.761-2.239 5-5 5h-28.683v5c0 2.761 2.239 5 5 5h33.683c2.761 0 5-2.239 5-5z",
    fill: "#2266d3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.bc1ae0f61c4ef23529a8a31d4ed3b2f9.svg";
export { ForwardRef as ReactComponent };